// admin/src/lib/ui.jsx — tiny presentational helpers shared across the admin screens.
// Formatting + a couple of dumb components; no data logic, no API calls (screens own those).
// Kept deliberately small — this is a plain internal tool, not a component library.

import React from 'react';

export const fmtInt = (n) => (n == null || n === '' ? '—' : Number(n).toLocaleString());
export const fmtDate = (s) => (s ? new Date(s).toLocaleDateString() : '—');
export const fmtDateTime = (s) => (s ? new Date(s).toLocaleString() : '—');
export const shortId = (id, n = 8) => (id ? String(id).slice(0, n) + '…' : '—');

// classify(kind) -> a one-line honest message for the taxonomy result the screen didn't
// specifically handle. Never rephrases the seam's own error strings (errors.js keeps them
// verbatim — the refusal messages are written for humans).
export function resultError(r) {
  if (!r) return 'no response';
  if (r.kind === 'auth') return r.error || 'not permitted (the server re-checked your role)';
  if (r.kind === 'invalid') return r.error + (r.errors && r.errors.length ? ' — ' + r.errors.join('; ') : '');
  if (r.kind === 'refused' || r.kind === 'insufficient_credits') return r.error;
  return r.error || 'something went wrong';
}

// Banner — one honest line of state. kind: 'err' | 'ok' | 'info' | 'warn'.
export function Banner({ kind = 'info', children }) {
  if (!children) return null;
  return <div className={'banner ' + kind}>{children}</div>;
}

// Field — a labeled control wrapper for the form grids.
export function Field({ label, hint, children, style }) {
  return (
    <div className="field" style={style}>
      {label && <label>{label}</label>}
      {children}
      {hint && <div className="hint">{hint}</div>}
    </div>
  );
}

// role/status as a small pill (reuses the .pill palette from admin.css)
export function RolePill({ role }) {
  return <span className={'pill ' + (role === 'admin' ? 'draft' : 'retired')}>{role}</span>;
}
